var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout",style:({ minHeight: _vm.bodyHeight + 'px' })},[_c('top',{attrs:{"showUser":_vm.showUser}}),_c('div',{staticClass:"content",style:({
      minHeight: !_vm.showUser ? _vm.bodyHeight - 297 + 'px' : _vm.bodyHeight - 195 + 'px',
    })},[_c('router-view')],1),_c('copyright')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }